import { useEffect, useState } from "react";

const PAIRS = [
  { role: "Banker", context: "Bank" },
  { role: "Accountant", context: "Expenses" },
  { role: "Tracker", context: "Savings" },
  { role: "CFO", context: "Life" },
  { role: "Owner", context: "Future" },
];

const useTypewriter = (target, speed = 80, pause = 2200) => {
  const [text, setText] = useState("");
  const [phase, setPhase] = useState("typing");

  useEffect(() => {
    let t;
    if (phase === "typing") {
      if (text.length < target.length) t = setTimeout(() => setText(target.slice(0, text.length + 1)), speed);
      else t = setTimeout(() => setPhase("pausing"), pause);
    } else if (phase === "pausing") {
      t = setTimeout(() => setPhase("deleting"), 300);
    } else {
      if (text.length > 0) t = setTimeout(() => setText(text.slice(0, -1)), speed * 0.55);
      else setPhase("done");
    }
    return () => clearTimeout(t);
  }, [text, phase, target, speed, pause]);

  return { text, done: phase === "done", reset: () => { setText(""); setPhase("typing"); } };
};

export const DualTypewriter = ({ prefix = "Be the", suffix = "of your" }) => {
  const [idx, setIdx] = useState(0);
  const current = PAIRS[idx];
  const role = useTypewriter(current.role);
  const context = useTypewriter(current.context);

  useEffect(() => {
    if (role.done && context.done) {
      const t = setTimeout(() => {
        setIdx((i) => (i + 1) % PAIRS.length);
      }, 400);
      return () => clearTimeout(t);
    }
  }, [role.done, context.done]);

  useEffect(() => {
    role.reset();
    context.reset();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idx]);

  return (
    <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl leading-tight tracking-tighter" data-testid="dual-typewriter">
      {prefix}{" "}
      <span className="inline-flex items-baseline">
        <span className="brand-text">{role.text}</span>
        <span className="inline-block w-[3px] h-[0.8em] brand-bg ml-1 animate-pulse" />
      </span>
      {" "}{suffix}{" "}
      <span className="inline-flex items-baseline">
        <span className="brand-text">{context.text}</span>
        <span className="inline-block w-[3px] h-[0.8em] brand-bg ml-1 animate-pulse" />
      </span>
    </h1>
  );
};
